<template>
  <v-flex>
    <div class="mb-6">
      <v-btn to="/user/list" color="blue">上一頁</v-btn>
    </div>

    <v-tabs v-model="tab" class="elevation-2">
      <v-tabs-slider></v-tabs-slider>

      <template v-for="tab in tabList">
        <v-tab>{{ tab.text }}</v-tab>

        <v-tab-item>
          <v-card flat tile>
            <v-card-text>
              <component :is="tab.component" :id="id" @setRoleId="setRoleId" :roleId="roleId"></component>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </template>
    </v-tabs>
  </v-flex>
</template>



<script>
import { mapState, mapActions } from "vuex";

import UserInfo from "@/components/User/Info";
import UserMachine from "@/components/User/Machine";

export default {
  components: {
    UserInfo,
    UserMachine
  },

  mixins: [],

  props: [],
  data() {
    return {
      id: 0,
      tab: null,

      tabList: [
        {
          text: "基本資料",
          component: "UserInfo"
        },
        {
          text: "機器權限",
          component: "UserMachine"
        }
      ],

      roleId: 0
    };
  },

  computed: {},
  watch: {},
  methods: {
    // 修改權限角色時，機器權限會做相對應的調整
    setRoleId(id) {
      this.roleId = id;
    }
  },

  mounted() {
    this.id = Number(this.$route.params.id);
  }
};
</script>

<style lang="scss" scoped>
</style>
